// Class: starling.display.ButtonState

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var ButtonState = function(){}

// Meta

ButtonState.__name__ = "starling.display.ButtonState";
ButtonState.__isInterface__ = false;
ButtonState.prototype = {
	
};
ButtonState.prototype.__class__ = ButtonState.prototype.constructor = $hxClasses["starling.display.ButtonState"] = ButtonState;

// Init



// Statics

ButtonState.isValid = function(state) {
	if(!(state == "up" || state == "down" || state == "over")) {
		return state == "disabled";
	} else {
		return true;
	}
}
ButtonState.UP = "up"
ButtonState.DOWN = "down"
ButtonState.OVER = "over"
ButtonState.DISABLED = "disabled"

// Export

exports.default = ButtonState;